module.exports = __webpack_public_path__ + "img/eye-icon.04c1eb2b.svg";